import React, { FC } from 'react';

import EmptyState from '@adsk/alloy-react-empty-state';

import { useTranslation } from '../../i18n';

const AttachmentsListEmptyState: FC = () => {
  const { t } = useTranslation();

  return (
    <EmptyState
      hideIllustration
      title={t('LIST_EMPTY_HEADER')}
      description={t('LIST_EMPTY_BODY')}
    />
  );
};

export default AttachmentsListEmptyState;
